import {ChangeEvent, ReactElement, useState} from 'react'
import {FormControl, TextField, Button} from '@material-ui/core'
import {Trans} from 'react-i18next'

import messages from '../../../../../../../assets/messages'
import {BANK_TRANSFER_FIELD_NAMES, BANK_TRANSFER_DEFAULT_FORM_FIELDS} from '../../../constants'
import {useStyles} from './styles'

type BankTransferFieldsProps = {
  bankTransferPaymentFields: Record<string, any> | null,
  onBankTransferSet: (fieldValues) => void,
  onClose: () => void,
}

function BankTransferFields(props: BankTransferFieldsProps): ReactElement {
  const classes = useStyles()
  const {bankTransferPaymentFields, onBankTransferSet, onClose} = props
  const [formFieldsValues, setFormFieldsValues] = useState(bankTransferPaymentFields || BANK_TRANSFER_DEFAULT_FORM_FIELDS)
  const isSubmitDisabled = (function() {
    return Object.values(formFieldsValues).some(value => !value.trim())
  })()

  const handleTextFieldChange = (event: ChangeEvent<HTMLInputElement>) => {
    const {value, name} = event.target
    setFormFieldsValues(prevValues => ({...prevValues, [name]: value}))
  }

  const handleSave = () => {
    onBankTransferSet(formFieldsValues)
    onClose()
  }

  return (
    <>
      <FormControl fullWidth>
        <TextField
          required
          type="text"
          name={BANK_TRANSFER_FIELD_NAMES.iban}
          value={formFieldsValues.iban}
          label={<Trans {...messages.bankAccountIBAN} /> }
          onChange={handleTextFieldChange}
        />
      </FormControl>
      <FormControl fullWidth>
        <TextField
          required
          type="text"
          name={BANK_TRANSFER_FIELD_NAMES.swiftCode}
          value={formFieldsValues.swiftCode}
          label={<Trans {...messages.swiftBicCode} /> }
          onChange={handleTextFieldChange}
        />
      </FormControl>
      <FormControl fullWidth>
        <TextField
          required
          type="text"
          name={BANK_TRANSFER_FIELD_NAMES.bankAccountHolderName}
          value={formFieldsValues.bankAccountHolderName}
          label={<Trans {...messages.bankAccountHolderName} /> }
          onChange={handleTextFieldChange}
        />
      </FormControl>
      <FormControl fullWidth>
        <TextField
          required
          type="text"
          name={BANK_TRANSFER_FIELD_NAMES.bankName}
          value={formFieldsValues.bankName}
          label={<Trans {...messages.bankName} /> }
          onChange={handleTextFieldChange}
        />
      </FormControl>
      {/* TODO: add ability to save payment method */}
      {/* <FormControlLabel
        control={
          <Checkbox
            required
            checked={formFieldsValues.isSaveMethodForFuture}
            name={BANK_TRANSFER_FIELD_NAMES.isSaveMethodForFuture}
            onChange={handleCheckboxFieldChange}
            color="primary"
          />
        }
        label={<Trans {...messages.saveThisAccountForFutureWithdrawals} />}
      /> */}
      <Button
        disabled={isSubmitDisabled}
        variant="contained"
        color="primary"
        onClick={handleSave}
        className={classes.button}
      >
        <Trans {...messages.saveAndContinue} />
      </Button>
    </>
  )
}

export {BankTransferFields}
